import { TFunction } from 'i18next'
import { z } from 'zod'

export const MANAGER_NAME_MAX_LENGTH = 50

export type ManagerFormMode = 'create' | 'edit'

const makeNameSchema = (t: TFunction<['organisation']>, requiredMessage: string) =>
  z
    .string()
    .trim()
    .min(1, requiredMessage)
    .max(
      MANAGER_NAME_MAX_LENGTH,
      t('organisation:managers.form.validation.nameMaxLength', { max: MANAGER_NAME_MAX_LENGTH }),
    )

export const makeManagerFormSchema = (t: TFunction<['organisation']>, mode: ManagerFormMode) =>
  z
    .object({
      avatar: z.array(z.instanceof(File)).optional(),
      email: z.string().trim().min(1, t('organisation:managers.form.validation.emailRequired')),
      firstName: makeNameSchema(t, t('organisation:managers.form.validation.firstNameRequired')),
      lastName: makeNameSchema(t, t('organisation:managers.form.validation.lastNameRequired')),
    })
    .superRefine((data, ctx) => {
      if (mode !== 'create' || !data.email) return

      if (!z.email().safeParse(data.email).success) {
        ctx.addIssue({
          code: 'custom',
          message: t('organisation:managers.form.validation.emailInvalid'),
          path: ['email'],
        })
      }
    })

export type ManagerFormData = z.infer<ReturnType<typeof makeManagerFormSchema>>
